import CabinetProducts from './CabProd'

export default CabinetProducts



// WEBPACK FOOTER //
// ./src/containers/CabinetProducts/index.js